module.exports = __webpack_public_path__ + "img/wiseivy-mark.1edd040f.png";